import { render } from "./HomeHeroBanner.vue?vue&type=template&id=2be8b930"
import script from "./HomeHeroBanner.vue?vue&type=script&lang=js"
export * from "./HomeHeroBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__